import React from 'react';
import styled from 'styled-components';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import Section from '../components/global/section';
import Hero from '../components/hero';

const StyledPrivacy = styled.div`
	section {
		padding: 4rem 0;
		h1 {
			margin-bottom: 1rem;
		}
		h2 {
			font-size: 1.5rem;
			margin-top: 2rem;
			margin-bottom: 1rem;
		}
		p {
			margin-bottom: 1em;
		}
		ul {
			padding: 1rem 0;
			li {
				line-height: 1.5rem;
				margin-left: 1rem;
				position: relative;
				&::before {
					content: '';
					background-color: #000;
					height: 7px;
					width: 7px;
					border-radius: 7px;
					position: absolute;
					left: -1rem;
					top: 8px;
				}
			}
		}
		@media all and (max-width: 500px) {
			padding: 2rem 0 3rem;
		}
	}
`;

export default () => (
	<PageTransition>
		<Page
			title="Terms of Use"
			desc="Please read these terms of use prior to using the starttalking.ca website and associated services."
		>
			<StyledPrivacy>
				<Hero img="/img/purple-grass.svg" alt="purple grass" />
				<Section bg="white">
					<div>
						<h1>Terms of Use</h1>
						<h2>General</h2>
						<p>
							Please read these terms of use prior to using the starttalking.ca
							website and associated services. Since you agree to be bound by
							these terms of use. Starttalking.ca reserves the right to change
							these Terms of Use, in whole or in part, at any time without
							notice. Accordingly, you should always review this page prior to
							using the starttalking.cawebsite and associated services in order
							to ensure that you have an understanding of the terms under which
							you are permitted access to this website.
						</p>
						<p>
							Your use of the starttalking.ca website and associated services
							shall be deemed acceptance of the terms contained herein. Should
							you disagree with the terms of use, you must discontinue your use
							of the starttalking.ca website and/or services.
						</p>

						<h2>Intended Audience</h2>
						<p>
							The material on this website is owned or licensed by Start Talking
							and is intended to be viewed by a North American audience. Start
							Talking makes no claim that the information located on the website
							is appropriate or may be downloaded legally from outside of North
							America.
						</p>
						<p>
							Subject to the Start Talking Privacy Policy which restricts the
							use of personal data, any material, information or ideas that you
							transmit or post on the website by any means will be treated as
							non-confidential and non-proprietary, and may be disseminated or
							used by Start Talking for any purpose it deems appropriate.
						</p>
						<p>
							The posting or transmittal of any unlawful, threatening,
							libellous, defamatory, scandalous, inflammatory, obscene,
							pornographic or profane material or any material that could
							constitute or encourage conduct that could be considered a
							criminal offense or violation of any law is prohibited.
						</p>
						<p>
							Access to the materials on this site may or may not be legal by
							certain persons in certain countries and therefore if this site is
							accessed from outside of North America you do so at your own risk
							and are responsible for compliance with the laws in your
							respective jurisdiction.
						</p>

						<h2>Copyright</h2>
						<p>
							The website design, text and graphics, and the selection and
							arrangement of such elements are copyrighted material of Start
							Talking or the entity from which Start Talking licenses the
							copyrighted material. Any reproduction, distribution,
							republication, posting, or transmission in any form or by any
							means without the prior written approval of Start Talking and the
							licensee is prohibited.
						</p>
						<p>
							You are granted permission to lawfully access and use the services
							available on this website and to download, archive and print in
							hard copy, portions of this website for personal use only,
							provided that you do not modify the materials and that you retain
							all proprietary notices contained in the materials. You are not
							permitted to sell any downloaded, archived or printed portions of
							this website.
						</p>
						<p>
							This permission terminates automatically, without the need of
							notification, if you breach any of these terms of use.
						</p>

						<h2>Trademarks</h2>
						<p>
							Start Talking and the startalking.ca domain name, the Start
							Talking logos, all page headers, custom graphics and button icons
							are service marks, trademarks and/or trade dress of Start Talking.
							In addition, there are numerous other trademarks, product names,
							company names, logo service marks, and/or trade dress indicated on
							the website that are the property of their respective owners and
							are displayed by Start Talking under license therefrom.
						</p>

						<h2>Site Warranty</h2>
						<p>
							The information, materials and services contained on this site,
							including but not limited to the graphics, links and other items,
							are being provided to you on a “as is” basis with no warranty.
							Start Talking does not warrant or guarantee the accuracy, adequacy
							or completeness of this information and materials, and expressly
							disclaims liability for any errors and/or omissions in this
							information and materials. To the maximum extent permitted by law,
							Start Talking disclaims all representations and warranties of any
							kind, whether expressed, implied or statutory, including without
							limitation the implied warranties of title, non-infringement,
							merchantability, and fitness for a particular purpose.
						</p>
						<p>
							In addition, Start Talking does not warrant, guarantee or make any
							representations regarding the security of accounts, or that this
							site is free from destructive materials, including but not limited
							to computer viruses, hackers, or other technical sabotage, nor
							does it warrant, guarantee or make any representations that access
							to this site will be fully accessible at all times, uninterrupted,
							or error free.
						</p>

						<h2>Limitation of Liability</h2>
						<p>
							In no event will Start Talking be liable for any damages,
							including without limitation direct or indirect, special,
							incidental, compensatory, exemplary or consequential damages,
							losses or expenses, including without limitation lost or
							misdirected orders, lost profits, lost registrations, lost
							goodwill, or lost or stolen programs or other data, however caused
							and under any theory of liability arising out of or in connection
							with (1) use of this site, or the inability to use this site by
							any party; or (2) any failure or performance, error, omission,
							interruption, defect, delay in operation or transmission; or (3)
							line or system failure or the introduction of a computer virus, or
							other technical sabotage, even if Start Talking, its employees or
							representatives thereof, are advised of the possibility or
							likelihood of such damages, losses or expenses.
						</p>

						<h2>Miscellaneous</h2>
						<p>
							Start Talking reserves the right to correct any inaccuracies or
							typographical errors in the information posted on its website, and
							shall have no liability for such errors. Information may be
							changed or updated without notice and prices and availability of
							goods and services are subject to change without notice.
						</p>
						<p>
							In the event that any provision(s) contained within these Terms of
							Use is/are held to be invalid or unenforceable for any reason,
							such invalidity or unenforceability shall not affect the remainder
							of this Agreement, and this Agreement shall be construed and
							enforced as if the invalid or unenforceable term(s) or
							provision(s) had not been included in this Agreement.
						</p>
						<p>
							Start Talking’s failure to insist upon or enforce strict
							performance of any term(s) or provision(s) contained herein shall
							not be construed as a waiver of any term, provision, right or
							obligation.
						</p>
					</div>
				</Section>
			</StyledPrivacy>
		</Page>
	</PageTransition>
);
